import * as React from 'react'
import {
  Box,
  Button,
  Heading,
  Stack,
  Text,
  List,
  ListItem,
  ListIcon,
  useColorModeValue as mode,
  Img,
  Link,
  Icon,
} from '@chakra-ui/react'

export const Teacher = (
  {
    name,
    desc,
    image,
    linkedin
  }
) => {
  return (
    <Box as="section" bg="blue.50">
      <a id="teacher" />

      <Box maxW={{ base: 'xl', md: '7xl' }} py="0" mx="auto" px={{ base: '6', md: '8' }}>
        <Stack
          direction={{ base: 'column', lg: 'row' }}
          spacing={{ base: '2rem', lg: '2rem' }}
          py="20"
          align={{ lg: 'center' }}
          justify="space-between"
        >
          <Box pos="relative" w={{ base: 'full', lg: '490px' }} alignSelf="center">
            <Img
              pos="relative"
              zIndex="1"
              h={{ lg: '440px' }}
              w="440px"
              borderRadius="30"
              objectFit="cover"
              src={image}
              alt={name}
            />
          </Box>
          <Box flex="1">
            <Heading
              as="h2"
              size="4xl"
              fontSize="5xl"
              mt="0"
              color="#000"
              fontFamily="Tomato Grotesk"
            >
              Meet Your Teacher
            </Heading>
            <Text as="h3" color="blue.500" mt="4" fontSize="xl" fontWeight="bold">
              {name}
            </Text>
            <Text as="div" color={mode('gray.900', 'gray.400')} mt="4" fontSize="lg" fontWeight="medium">
              {desc}
            </Text>
            <Link
              as="a"
              href={linkedin}
              target="_blank"
            >
              <Img
                src="./img/social/linkedin.svg"
                htmlHeight="18px"
                htmlWidth="18px"
                pt="15"
              />
            </Link>
                        
          </Box>
        </Stack>

      </Box>
    </Box>
  )
}